module.exports = __webpack_public_path__ + "img/booking-wixinScan.715f7e34.png";